import OneRepMaxChartStatusContext from "../contexts/OneRepMaxChartStatusContext";
import type { Status } from "types/Status";
import useDefinedContext from "hooks/useDefinedContext";

function useOneRepMaxChartStatus(): Status {
  return useDefinedContext(OneRepMaxChartStatusContext);
}

export default useOneRepMaxChartStatus;
